import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithTokenHandling } from '../baseQuery';
import { STRATEGY_TAG_TYPE, STRATEGY_METRIC_TYPE } from './constants';

// Tag for caching templates by strategy type
export const STRATEGY_TEMPLATES_TAG = 'StrategyTemplates';

// Base API for all strategy endpoints
export const strategyApi = createApi({
  reducerPath: 'strategy',
  baseQuery: baseQueryWithTokenHandling,
  tagTypes: [STRATEGY_TAG_TYPE, STRATEGY_METRIC_TYPE, STRATEGY_TEMPLATES_TAG],
  endpoints: () => ({}),
});
